export const baseFormColumn = () => {
  return [
    {
      prop: 'feedback',
      name: '审批意见',
      type: 'textarea',
      span: 24,
    },
  ];
};

export const baseFormRules = () => {
  return {
    feedback: [{ required: true, message: '审批意见必填', trigger: ['change', 'blur'] }],
  };
};
